// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zG-z","hovered":"AG-z","hoverImage":"BG-z","mainImage":"CG-z","imageNoBackground":"DG-z","fullSizeImage":"EG-z"};